"use client"

import React from "react"
import axios from "axios"
import { useNavigate } from "react-router-dom"
import { Box, Button, Typography, Paper, CircularProgress } from "@mui/material" // Material UI কম্পোনেন্ট ইম্পোর্ট করা হয়েছে
import { ExitToApp as ExitToAppIcon } from "@mui/icons-material" // আইকন ইম্পোর্ট করা হয়েছে
import BaseURL from "../../api/AppURL";

const Logout = ({ onLogout }) => {
  const navigate = useNavigate()
  const [loading, setLoading] = React.useState(false)

  const handleLogout = () => {
    setLoading(true)
    const token = localStorage.getItem("auth_token")

    axios
      .post(
        `${BaseURL}/logout`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        },
      )
      .then(() => {
        localStorage.removeItem("auth_token")
        onLogout() // App.js এ লগআউট স্টেট আপডেট
        navigate("/login") // লগআউট সফল হলে লগইন পেজে রিডাইরেক্ট
      })
      .catch((err) => {
        console.error("Logout error:", err)
        // Even if API call fails, clear token and redirect to login for security
        localStorage.removeItem("auth_token")
        onLogout()
        navigate("/login")
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
      }}
    >
      <Paper elevation={3} sx={{ p: 4, maxWidth: 400, width: "100%", borderRadius: 2, textAlign: "center" }}>
        <ExitToAppIcon sx={{ fontSize: 80, color: "primary.main", mb: 2 }} />
        <Typography variant="h5" component="h1" gutterBottom sx={{ mb: 2, fontWeight: "bold" }}>
          Logout
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Are you sure you want to log out?
        </Typography>
        <Button
          variant="contained"
          color="error"
          onClick={handleLogout}
          disabled={loading}
          fullWidth
          sx={{ py: 1.5 }}
          startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
        >
          {loading ? "Logging out..." : "Logout"}
        </Button>
      </Paper>
    </Box>
  )
}

export default Logout
